import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";

import { useDebouncedMutation } from "../../../../common/Utils/useDebouncedMutation";
import { SetStatusFN } from "./SetStatusFN";
import { useTodoEditSetBodyMutation } from "./__generated__/useTodoEditSetBodyMutation.graphql";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";

const key = "set_body";
export function useTodoEditSetBody(
  id: string,
  remoteBody: string,
  setStatus: SetStatusFN
) {
  const { currentEmployeeId } = usePersistedEmployeeId();
  const [updateBody, loading] = useMutation<useTodoEditSetBodyMutation>(graphql`
    mutation useTodoEditSetBodyMutation(
      $id: ID!
      $body: String!
      $employeeId: ID
    ) {
      todo(todoId: $id, employeeId: $employeeId) {
        updateBody(newBody: $body) {
          id
          body
          ...TodoEditTimeline_todo @defer
        }
      }
    }
  `);

  const saveBody = useCallback(
    (body: string) =>
      updateBody({
        onError: () => setStatus(key, "error"),
        onCompleted: () => setStatus(key, "saved"),
        variables: {
          id,
          body,
          employeeId: currentEmployeeId,
        },
      }),
    [id, setStatus, updateBody, currentEmployeeId]
  );

  return [
    ...useDebouncedMutation(remoteBody, saveBody, undefined, undefined, () =>
      setStatus(key, "saving")
    ),
    loading,
  ] as const;
}
